import { RootState } from 'types/root-state';
import { categoriesListingState } from './slice';

const selectDomain = (state: RootState) => state.spl.categoriesListing || categoriesListingState;

export const selectConfigurators = (state: RootState) => selectDomain(state).data.configurators;
export const selectInstallationDeadline = (state: RootState) =>
	selectDomain(state).data.deadlines.executionStart.installationDays;
export const selectMeasureDeadline = (state: RootState) =>
	selectDomain(state).data.deadlines.executionStart.measureDays;
export const selectConfiguratorsNetwork = (state: RootState) => selectDomain(state).network;
export const selectCompensationStatus = (state: RootState) =>
	selectDomain(state).data.isCompensationEnabled;
